import gql from "graphql-tag";

//Get countries iso codes
export const GET_COUNTRIES = gql`
    query{
        getCountries{
            name
            iso_country_code
            iso_country_code_3
            dialing_code
        }
    }
`;